module.exports = __webpack_public_path__ + "static/img/1.4e56eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-sponsor-det/1.jpg
// module id = 6ppT
// module chunks = 1